import {
  EinzelBuchung, EinzelBuchungJson, Rechnung, Reisen, Stammdaten, TeilnehmerCollection,
  Zahlung
} from './types';
import {firebaseObjectToArray, valueOrZero} from '../utils/tools';
import {BehaviorSubject} from 'rxjs';
import {Moment} from 'moment';
import * as moment from 'moment';

// Registrierter User mit Stammdaten, Buchungen und Zahlungen
export class User extends Stammdaten {
  teilnehmer: TeilnehmerCollection;
  rechnung = new BehaviorSubject<Rechnung>(null);
  zahlungen = new BehaviorSubject<Zahlung[]>(null);
  zahlungenSumme: number;
  buchungenBezahltSumme: number;
  _emailLastDate: Moment;
  _guthaben: number = null;

  buchungsKostenFaellig: number;
  buchungsKostenOffen: number;
  faelligerBetrag: number;
  offenerBetrag: number;

  static sortByName(a: User, b: User) {
    const aName = a.name();
    const bName = b.name();
    return aName > bName ? 1 : -1;
  }

  constructor(uid: string) {
    super(uid);
    // console.log('User()', uid);
  }

  get emailLastDate(): Moment {
    return this._emailLastDate;
  }

  get guthaben(): number {
    return this._guthaben;
  }

  get faelligerBetragZahlbar(): boolean {
    return this.faelligerBetrag > 0;
  }

  get offenerBetragZahlbar(): boolean {
    return this.offenerBetrag > 0 && this.offenerBetrag !== this.faelligerBetrag;
  }

  setUserData(userData, archiv: boolean) {
    this.fromJson(userData.stammdaten);
    this.teilnehmer = new TeilnehmerCollection(userData.weitereTeilnehmer);
    this.loadZahlungen(userData.zahlungen, archiv);
    this._emailLastDate = userData.emailLastDate ? moment(userData.emailLastDate) : null;
    this._guthaben = valueOrZero(userData.guthaben);
  }

  setBuchungen(reisen: Reisen, buchungenJson: EinzelBuchungJson[], archiv: boolean) {
    const buchungen = buchungenJson
      .filter(buchungJson => buchungJson != null) // avoid race conditions while deleting
      .filter(buchungJson => !buchungJson.archiv || archiv)
      .map(buchungJson => EinzelBuchung.fromJson(buchungJson, reisen, this, this.teilnehmer));
    const rechnung = buchungen.length ? new Rechnung(buchungen) : null;
    if (rechnung) {
      this.updateBetraege(rechnung);
    }
    this.rechnung.next(rechnung);
  }

  private updateBetraege(rechnung: Rechnung) {
    this.buchungenBezahltSumme = rechnung.alleItems.gesamtBezahlt;
    this.buchungsKostenFaellig = this.buchungenBezahltSumme + rechnung.buchungenMitKosten.faelligerBetrag;
    this.buchungsKostenOffen = this.buchungenBezahltSumme + rechnung.buchungenMitKosten.offenerBetrag;
    this.faelligerBetrag = this.buchungsKostenFaellig - this.zahlungenSumme;
    this.offenerBetrag = this.buchungsKostenOffen - this.zahlungenSumme;
  }

  private loadZahlungen(zahlungenJson, archiv: boolean) {
    if (!zahlungenJson) {
      this.zahlungenSumme = 0;
      this.zahlungen.next(null);
      return;
    }
    const zahlungen: Zahlung[] = firebaseObjectToArray(zahlungenJson).map(z => new Zahlung().fromJson(z))
      .filter(z => !z.archiv || archiv)
      .sort((a, b) => Zahlung.sortByDate(a, b));
    this.zahlungenSumme = zahlungen.reduce((prev, curr) => prev + curr.betrag, 0);
    const rechnung = this.rechnung.getValue();
    if (rechnung) {
      this.updateBetraege(rechnung);
    }
    this.zahlungen.next(zahlungen);
  }
}
